import './eezy-logo--white.svg';
import './vecteezy-logo--black.svg';
import './vecteezy-logo--orange-on-white.svg';
import './vecteezy-logo--white-on-orange.jpg';
import './vecteezy-logo--mountain.jpg';
import './vecteezy-opengraph-rebrand.jpg';
